import React from 'react'
import './Home.css'
import { Row, Col } from 'reactstrap'
import DashboardWidget from '../../Components/Home/DashboardWidget'
import 'react-toastify/dist/ReactToastify.css';

function Home() {

    return (
        <div className="container">
            <Row>
                <Col>
                    <DashboardWidget />
                </Col>
            </Row>
        </div>
    )
}

export default Home
